import React, { useState, useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import NewReportPrompt from "../../components/new-report/newReportPrompt.component";
import TvWeeklySchedule from "../../components/tv-weekly-sch/tvWeeklySchedule.component";
import SimulateReport from "../../components/simulate-report/simulateReport.component";
import Optimization from "../../components/optimization/optimization.component";
import OptimizationPage from "../../components/optimization-report/optimizationPage.component";
import OptimizationOutputReport from "../../components/optimization-output-report/OptimizationOutputReport";
import ScaleLoader from "react-spinners/ScaleLoader";
import axios from "axios";

const tabs = [
  "newReport",
  "TV_WEEKLY_SCHEDULE",
  "Characteristics",
  "optimizationPage",
  "optimizationOutput",
];

export const ReportContext = React.createContext({});

function MainContent(props) {
  const { newReport, setNewReport, navToStatus, setNavToStatus } = props
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [networks, setNetworks] = useState([]);
  const [contentTypes, setContentTypes] = useState([]);
  const [year, setYear] = useState(null);
  const [week, setWeek] = useState(null);
  const [period, setPeriod] = useState(null);
  const [reportId, setReportId] = useState(null);
  const [reportType, setReportType] = useState("Optimize");
  const [spec, setSpec] = useState({})
  const [temp, setTemp] = useState({})
  const [selectedMediums, setSelectedMediums] = React.useState([]);
  const [simulateData, setSimulateData] = React.useState([]);
  const [selectedMetrics, setSelectedMetrics] = React.useState({});
  const [enableAutoRefresh, setEnableAutoRefresh] = React.useState({});

  const { authState, authService } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    if (!authState.isAuthenticated || authState.accessToken === undefined) {
      setUserInfo(null);
      authService.redirect();
    } else {
      authService.getUser().then(info => {
        axios.defaults.headers.common["access_token"] = authState.accessToken;
        axios.defaults.headers.common["login_email"] = info.email;
        axios.interceptors.response.use(
          function (response) {
            return response;
          },
          function (error) {
            var event = new CustomEvent("espn.xhrError", {
              detail: {
                error,
              },
            });
            window.dispatchEvent(event);
            return Promise.reject(error);
          }
        );
        setUserInfo(info);
      }).catch(error => authService.redirect());

      // authService.updateAuthState().then(info => console.log(info));
      // console.log(al)
    }

  }, [authState, authService]);

  useEffect(() => {
    if (newReport) {
      navigateToCreateNewReport();
      setNewReport(false);
    }
    if (navToStatus) {
      navigateToOptimizationReportStatus();
      setNavToStatus(false);
    }
  }, [newReport, navToStatus])

  const handleNext = currentTab => {
    const currentTabIndex = tabs.indexOf(currentTab);
    if (currentTabIndex < tabs.length - 1) {
      let tab = tabs[currentTabIndex + 1];
      setActiveTab(tab);
    }
  };
  const handlePrev = currentTab => {
    const currentTabIndex = tabs.indexOf(currentTab);
    if (currentTabIndex > 0) {
      let tab = tabs[currentTabIndex - 1];
      setActiveTab(tab);
    }
  };
  const gotoTab = tab => {
    setActiveTab(tab)
  }

  const navigateToCreateNewReport = () => {
    setNetworks([]);
    setContentTypes([]);
    setReportType("Optimize");
    setYear(null);
    setWeek(null);
    setPeriod(null);
    setSpec({});
    setTemp({});
    setSelectedMediums([]);
    setSimulateData([]);
    setSelectedMetrics({})
    setActiveTab(tabs[0]);
  };
  const navigateToOptimizationOutput = () => {
    setActiveTab(tabs[4]);
  };
  const navigateToOptimizationReportStatus = () => {
    setActiveTab(tabs[3]);
  };
  const toggleAutoRefresh = _ => {
    setEnableAutoRefresh(!enableAutoRefresh)
  }
  const reportContext = {
    activeTab,
    handleNext,
    handlePrev,
    networks,
    setNetworks,
    contentTypes,
    setContentTypes,
    year,
    setYear,
    week,
    setWeek,
    period,
    setPeriod,
    reportType,
    setReportType,
    navigateToCreateNewReport,
    navigateToOptimizationOutput,
    navigateToOptimizationReportStatus,
    spec,
    setSpec,
    gotoTab,
    temp,
    setTemp,
    selectedMediums,
    setSelectedMediums,
    simulateData,
    setSimulateData,
    selectedMetrics,
    setSelectedMetrics,
    userInfo,
    reportId,
    setReportId,
    enableAutoRefresh,
    toggleAutoRefresh
  };

  return (
    <>
      {authState.isAuthenticated && userInfo ? <ReportContext.Provider value={reportContext}>
        {activeTab === "newReport" ? (
          <NewReportPrompt />
        ) : activeTab === "Characteristics" ? reportType === "Optimize" ? <Optimization /> : (
          <SimulateReport />
        ) : activeTab === "optimizationPage" ? (
          <OptimizationPage />
        ) : activeTab === "optimizationOutput" ? (
          <OptimizationOutputReport />
        ) : (
                  activeTab === "TV_WEEKLY_SCHEDULE" && <TvWeeklySchedule />
                )}
      </ReportContext.Provider>
        :
        <div style={{ margin: "10rem" }}>
          <center>
            <ScaleLoader
              color={"#1976d2"}
              align="center"
              loading={!authState.isAuthenticated || userInfo === null}
              height={40}
              width={10}
              radius={5}
            />
          </center>
        </div>
      }
    </>
  );
}
export default MainContent;
